import React, { useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Box, Grid, Stack, Typography } from "@mui/material";
import DialogComponent from "../reusableComponents/Dialog";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Search from "../components/Search";
import DateField from "../components/DateField";
import { ItemBox, Title } from "./styles";
import { Header, TopGrid } from "../styles";
import Repo from "../../Repository/Repo";

function ExpiredItems() {
  const history = useHistory();
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    date: "",
    selectedId: "",
    modal: false,
    selected: "",
    items: [],
  });

  useEffect(() => {
    getExpiredItems();
  }, []);

  const handleInput = (e) => {
    let { name, value } = e.target;
    if (name == "date") {
      getExpiredItems(value);
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };

  const getExpiredItems = async (val) => {
    // clearFields("loading");
    let { data } = await Repo.default({
      request: {
        method: "getExpiredItems",
        data: {
          company_code: companyCode,
          startDate: val ? val : state.date,
          endDate: val ? val : state.date,
        },
      },
    });
    console.log("data", data);
    // setDatebook(data.response.data.bills);
    setState((prev) => ({
      ...prev,
      items: data.response.data.items,
      // loading: false,
    }));
    // setData(data.response.data);
  };
  // const searchedItems = () => {
  //   const value = state.items || [];
  //   console.log("value", value);
  //   return value;
  // };

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={7} md={5} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}>
              Expired Items
            </Typography>
          </Grid>
          <Grid align="center" item lg={2} md={4} xs={12}>
            <DateField
              name={"date"}
              value={state.date}
              onChange={handleInput}
            />
          </Grid>
        </TopGrid>
      </Header>
      <Box sx={{ mb: 3, position: "relative", mt: "100px" }}>
        {state.items.length > 0 ? (
          state.items.map((item, index) => {
            const formatDate = (timestamp) =>
              new Date(timestamp * 1000).toLocaleDateString();
         const quantityExpired = item?.batchNumber.reduce((acc,curr)=> {
               acc = curr.quantity
               return acc
            },0)
            console.log('ite', item)
            return (
              <ItemBox key={index} container>
                <Grid item xs={4}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#4EAF51", cursor: "pointer" }}>
                    {item.name}
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ display: "flex" }}>
                  <Title>Date :</Title>
                  <Title sx={{ color: "#565656" }}>{formatDate(item?.created_at)}</Title>
                </Grid>
                <Grid item xs={2.8} sx={{ display: "flex" }}>
                  <Title>Quantity :</Title>
                  <Title sx={{ color: "#565656" }}>{ quantityExpired}</Title>
                </Grid>
                <Grid item xs={2.2} sx={{ display: "flex" }}>
                  <Title>Expiry Date :</Title>
                  <Title sx={{ color: "#565656" }}>
                    {formatDate(item.expiryDate)}
                  </Title>
                </Grid>
              </ItemBox>
            );
          })
        ) : (
          <p>No expired items available</p>
        )}
      </Box>

      <DialogComponent
        title="Add Cash"
        open={state.modal}
        onClose={() => toggle("modal")}
        // dialogContent={ }
      />

      {/* <Stack alignItems="center" justifyContent="center">
        <ClipLoader size={50} color="#4DAF51" loading={state.loading} />
      </Stack> */}
    </Box>
  );
}

export default ExpiredItems;
